import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import { type CertificateType, WhitelistedEmail } from "../api/dto";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { Paragraph } from "../components/Paragraph";
import { useRefresh } from "../components/RefreshController";

export const DeleteCertificateTypeModal: FC<{ certificateType: CertificateType }> = (props) => {
  const { deleteCertificateType } = useApiCall();
  const refresh = useRefresh();
  const [email, setEmail] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    await deleteCertificateType(props.certificateType.id).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };

  return (
    <>
      <Paragraph>
        <div>Weet je zeker dat je dit type certificaat wilt verwijderen?</div>
        <div>
          <strong>{props.certificateType.name}</strong>.
        </div>
      </Paragraph>
      <ModalFooter text={"Verwijderen"} icon={faTimes} onSubmit={save} />
    </>
  );
};
